import { create } from "zustand";

export type AvailabilityTierMap = {
  [productId: number]: { productAvailabilityId?: number; active?: boolean };
};

type State = {
  availabilityMap: AvailabilityTierMap;
  setAvailabilityMap: (map: AvailabilityTierMap) => void;
  toggleAvailability: (
    productId: number,
    productAvailabilityId: number,
  ) => void;
};

export const useAvailabilityTierStore = create<State>((set, get) => ({
  availabilityMap: {},
  setAvailabilityMap: (map) => set({ availabilityMap: map }),
  toggleAvailability: (productId, productAvailabilityId) => {
    const map = { ...get().availabilityMap };
    map[productId] = { ...map[productId] };
    map[productId] = { productAvailabilityId, active: !map[productId].active };
    set({ availabilityMap: map });
  },
}));
